/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {TrueGritGameAssets} from "./TrueGritGameAssets";
import {TrueGritSound} from "./sound/TrueGritSound";
import {TrueGritBackgroundElements} from "./view/TrueGritBackgroundElements";
import {TrueGritWinPresentation} from "./gameflow/TrueGritWinPresentation";
import {TrueGritNormalBetPresentation} from "./gameflow/TrueGritNormalBetPresentation";
import {TrueGritNormalResultPresentation} from "./gameflow/TrueGritNormalResultPresentation";
import {TrueGritIdleNormalPresentation} from "./gameflow/TrueGritIdleNormalPresentation";
import {TrueGritModel} from "./TrueGritModel";
import {TrueGritGameMode} from "./server/TrueGritGameMode";
import {TrueGritForegroundElements} from "./view/TrueGritForegroundElements";
import {TrueGritAvalancheIdlePresentation} from "./gameflow/avalanche/TrueGritAvalancheIdlePresentation";
import {TrueGritAvalancheBetPresentation} from "./gameflow/avalanche/TrueGritAvalancheBetPresentation";
import {TrueGritAvalancheFillUpReelsPresentation} from "./gameflow/avalanche/TrueGritAvalancheFillUpReelsPresentation";
import {TrueGritWinPresentations} from "./view/TrueGritWinPresentations";
import {TrueGritSymbolBoxView} from "./view/TrueGritSymbolBoxView";
import {TrueGritWaysView} from "./view/TrueGritWaysView";
import {TrueGritTotalWinView} from "./view/TrueGritTotalWinView";
import {TrueGritInitialWinOnTopView} from "./view/TrueGritInitialWinOnTopView";
import {TrueGritInitialWinBelowView} from "./view/TrueGritInitialWinBelowView";
import {TrueGritReelBackgroundView} from "./view/TrueGritReelBackgroundView";
import {TrueGritWildTransformView} from "./view/TrueGritWildTransformView";
import {TrueGritMainAllReelsView} from "./view/reels/TrueGritMainAllReelsView";
import {TrueGritTopReelView} from "./view/reels/TrueGritTopReelView";
import {TrueGritSymbolBoxExplosionView} from "./view/TrueGritSymbolBoxExplosionView";
import {TrueGritScatterSymbols} from "./pooling/TrueGritScatterSymbols";
import {TrueGritFreeSpinIntroView} from "./view/freespin/TrueGritFreeSpinIntroView";
import {TrueGritFreeSpinIdlePresentation} from "./gameflow/freespin/TrueGritFreeSpinIdlePresentation";
import {TrueGritFreeSpinBetPresentation} from "./gameflow/freespin/TrueGritFreeSpinBetPresentation";
import {TrueGritFreeSpinResultPresentation} from "./gameflow/freespin/TrueGritFreeSpinResultPresentation";
import {TrueGritFreeSpinWinPresentation} from "./gameflow/freespin/TrueGritFreeSpinWinPresentation";
import {TrueGritFreeSpinOutroView} from "./view/freespin/TrueGritFreeSpinOutroView";
import {TrueGritBottomReelView} from "./view/reels/TrueGritBottomReelView";
import {TrueGritSuperFreeSpinIntroView} from "./view/superfreespin/TrueGritSuperFreeSpinIntroView";
import {TrueGritSuperFreeSpinOutroView} from "./view/superfreespin/TrueGritSuperFreeSpinOutroView";
import {TrueGritSuperFreeSpinWinPresentation} from "./gameflow/superfreespin/TrueGritSuperFreeSpinWinPresentation";
import {TrueGritSuperFreeSpinIdlePresentation} from "./gameflow/superfreespin/TrueGritSuperFreeSpinIdlePresentation";
import {TrueGritSuperFreeSpinBetPresentation} from "./gameflow/superfreespin/TrueGritSuperFreeSpinBetPresentation";
import {ResourceCreator} from "./resourcecreator/ResourceCreator";
import {TrueGritFSToSuperFSIntroView} from "./view/freespin/TrueGritFSToSuperFSIntroView";
import {TrueGritGritGirlSymbols} from "./pooling/TrueGritGritGirlSymbols";
import {TrueGritTotalBigWinView} from "./view/TrueGritTotalBigWinView";
import {TrueGritMaxWinOutroView} from "./view/TrueGritMaxWinOutroView";
import {TrueGritLuckyDrawView} from "./view/TrueGritLuckyDrawView";
import {TrueGritReelSplitView} from "./view/TrueGritReelSplitView";
import {TrueGritScatterAnimationView} from "./view/TrueGritScatterAnimationView";
import {TrueGritAnticipationView} from "./view/TrueGritAnticipationView";
import {SnowParticlesView} from "./view/particles/SnowParticlesView";
import {TrueGritXWaysAndSplitView} from "./view/TrueGritXWaysAndSplitView";
import {TrueGritMuzzleFlashView} from "./view/TrueGritMuzzleFlashView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {TrueGritGPUPushView} from "./view/TrueGritGPUPushView";
import {TrueGritIntroConfig} from "./intro/TrueGritIntroConfig";

export class TrueGrit extends SlotGame {
    public static model:TrueGritModel;
    public static assetLoader:AssetLoader;
    public static soundPlayer:TrueGritSound;
    public static gpuPushView:TrueGritGPUPushView;
    public static backgroundElements:TrueGritBackgroundElements;
    public static foregroundElements:TrueGritForegroundElements;
    public static winPresentations:TrueGritWinPresentations;
    public static gameFlowController:GameFlowController;
    public static allReelsView:TrueGritMainAllReelsView;
    public static topReelView:TrueGritTopReelView;
    public static bottomReelView:TrueGritBottomReelView;
    public static reelBackgroundView:TrueGritReelBackgroundView;
    public static symbolBoxView:TrueGritSymbolBoxView;
    public static symbolBoxExplosionView:TrueGritSymbolBoxExplosionView;
    public static waysView:TrueGritWaysView;
    public static totalWinView:TrueGritTotalWinView;
    public static initialWinTopView:TrueGritInitialWinOnTopView;
    public static initialWinBelowView:TrueGritInitialWinBelowView;
    public static wildTransformView:TrueGritWildTransformView;
    public static fsIntroView:TrueGritFreeSpinIntroView;
    public static luckyDrawView:TrueGritLuckyDrawView;
    public static scatterAnimationView:TrueGritScatterAnimationView;
    public static fsToSuperFsIntroView:TrueGritFSToSuperFSIntroView;
    public static fsOutroView:TrueGritFreeSpinOutroView;
    public static trueGritScatterSymbols:TrueGritScatterSymbols;
    public static trueGritGritGirlSymbols:TrueGritGritGirlSymbols;
    public static superFsIntroView:TrueGritSuperFreeSpinIntroView
    public static superFOutroView:TrueGritSuperFreeSpinOutroView;
    public static avalancheFillUpReels:TrueGritAvalancheFillUpReelsPresentation;
    public static totalBigWinView:TrueGritTotalBigWinView;
    public static maxWinOutroView:TrueGritMaxWinOutroView;
    public static reelSplitView:TrueGritReelSplitView;
    public static anticipationView:TrueGritAnticipationView;
    public static splitSymbolView:TrueGritXWaysAndSplitView;
    public static snowParticles: SnowParticlesView;
    public static introConfig:TrueGritIntroConfig = new TrueGritIntroConfig();
    public static muzzleFlashView:TrueGritMuzzleFlashView;

    private _winPres:TrueGritWinPresentation;
    private _freeSpinWinPres:TrueGritFreeSpinWinPresentation;
    private _superFreeSpinWinPres:TrueGritSuperFreeSpinWinPresentation;

    constructor() {
        super();
    }

    public init():Promise<NolimitPlugin> {
        return super.init().then((value:NolimitPlugin) => {
            TrueGrit.model = new TrueGritModel(SlotGame.apiPlugin, true);
            TrueGrit.gameFlowController = new GameFlowController(SlotGame.apiPlugin, TrueGrit.model);
            TrueGrit.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            TrueGrit.trueGritScatterSymbols = new TrueGritScatterSymbols();
            TrueGrit.trueGritGritGirlSymbols = new TrueGritGritGirlSymbols();

            //Main game
            this._winPres = new TrueGritWinPresentation();
            const idleNormal:TrueGritIdleNormalPresentation = new TrueGritIdleNormalPresentation();
            const reelStart:TrueGritNormalBetPresentation = new TrueGritNormalBetPresentation();
            const normalResult:TrueGritNormalResultPresentation = new TrueGritNormalResultPresentation();

            //Free spin
            this._freeSpinWinPres = new TrueGritFreeSpinWinPresentation();
            const freeSpinIdle:TrueGritFreeSpinIdlePresentation = new TrueGritFreeSpinIdlePresentation();
            const freeSpinReelStart:TrueGritFreeSpinBetPresentation = new TrueGritFreeSpinBetPresentation();
            const freeSpinResult:TrueGritFreeSpinResultPresentation = new TrueGritFreeSpinResultPresentation();

            //Super free spin
            this._superFreeSpinWinPres = new TrueGritSuperFreeSpinWinPresentation();
            const superFreeSpinIdle:TrueGritSuperFreeSpinIdlePresentation = new TrueGritSuperFreeSpinIdlePresentation();
            const superFreeSpinReelStart:TrueGritSuperFreeSpinBetPresentation = new TrueGritSuperFreeSpinBetPresentation();

            const avalancheIdle:TrueGritAvalancheIdlePresentation = new TrueGritAvalancheIdlePresentation();
            const avalancheStart:TrueGritAvalancheBetPresentation = new TrueGritAvalancheBetPresentation();
            TrueGrit.avalancheFillUpReels = new TrueGritAvalancheFillUpReelsPresentation();

            TrueGrit.gameFlowController.addGameModeFlowStatePresentationMap(TrueGritGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, this._winPres]
            ]));
            TrueGrit.gameFlowController.addGameModeFlowStatePresentationMap(TrueGritGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheStart],
                [FlowState.RESULT, TrueGrit.avalancheFillUpReels],
                [FlowState.WIN, this._winPres]
            ]));
            TrueGrit.gameFlowController.addGameModeFlowStatePresentationMap(TrueGritGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freeSpinIdle],
                [FlowState.BET, freeSpinReelStart],
                [FlowState.RESULT, freeSpinResult],
                [FlowState.WIN, this._freeSpinWinPres]
            ]));
            TrueGrit.gameFlowController.addGameModeFlowStatePresentationMap(TrueGritGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheStart],
                [FlowState.RESULT, TrueGrit.avalancheFillUpReels],
                [FlowState.WIN, this._freeSpinWinPres]
            ]));
            TrueGrit.gameFlowController.addGameModeFlowStatePresentationMap(TrueGritGameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, superFreeSpinIdle],
                [FlowState.BET, superFreeSpinReelStart],
                [FlowState.RESULT, freeSpinResult],
                [FlowState.WIN, this._superFreeSpinWinPres]
            ]));
            TrueGrit.gameFlowController.addGameModeFlowStatePresentationMap(TrueGritGameMode.FREESPIN_SUPER_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheStart],
                [FlowState.RESULT, TrueGrit.avalancheFillUpReels],
                [FlowState.WIN, this._superFreeSpinWinPres]
            ]));

            return value;
        });
    }

    public getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value:NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(TrueGritGameAssets.RESOURCES_GROUPS);
            TrueGrit.assetLoader = new AssetLoader(TrueGrit.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const imageLoader = new ImgLoader( NolimitApplication.resourcePath + "/resources/");
            imageLoader.add("ways", "images/ways.png");
            imageLoader.add("bigWinLevel1", "images/bigwin/level1.png");
            imageLoader.add("bigWinLevel2", "images/bigwin/level2.png");
            imageLoader.add("bigWinLevel3", "images/bigwin/level3.png");
            imageLoader.add("bigWinLevel4", "images/bigwin/level4.png");
            imageLoader.add("bigWinLevel5", "images/bigwin/level5.png");
            imageLoader.add("bigWinLevel6", "images/bigwin/level6.png");
            imageLoader.add("bigwinFrameSource",  "images/bigwin/bwFrame.png");
            imageLoader.add("bigwinMaskSource",   "images/bigwin/bwMask.jpg");

            const promises = Promise.all([fontLoader.load(), imageLoader.load(), TrueGrit.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values:any) =>
                ResourceCreator.createResources().then(() => {
                    return value;
                })
            ).then((values:any) => {
                    TrueGrit.createViewsAndComponents();
                    TrueGrit.soundPlayer.switchMusic(TrueGrit.model.data.mode);
                    return values;
                }
            );
        });
    }

    public getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.

        //Do restores not handled by views
        if(TrueGrit.model.isRestore) {
            if(TrueGrit.model.data.nextMode == TrueGritGameMode.NORMAL_AVALANCHE){
                this._winPres.setRestores();
            }
            if(TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_AVALANCHE){
                this._freeSpinWinPres.setRestores();
            }
            if(TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE){
                this._superFreeSpinWinPres.setRestores();
            }
        }

        return super.getReadyToStart().then((value:NolimitPlugin) => {
            return value;
        });
    }

    public start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        TrueGrit.gpuPushView.cleanup();
        return super.start().then((value:NolimitPlugin) => {
            TrueGrit.gameFlowController.start();
            return value;
        });
    }

    public static isWinBelowStake():boolean {
        return this.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    private static createViewsAndComponents():void {
        //Non views
        TrueGrit.soundPlayer = new TrueGritSound();

        //Views
        TrueGrit.snowParticles = new SnowParticlesView();
        TrueGrit.gpuPushView = new TrueGritGPUPushView();
        TrueGrit.initialWinTopView = new TrueGritInitialWinOnTopView();
        TrueGrit.scatterAnimationView = new TrueGritScatterAnimationView();

        TrueGrit.trueGritGritGirlSymbols.init();
        TrueGrit.trueGritScatterSymbols.init();
        TrueGrit.topReelView = new TrueGritTopReelView();
        TrueGrit.bottomReelView = new TrueGritBottomReelView();
        TrueGrit.backgroundElements = new TrueGritBackgroundElements();
        TrueGrit.backgroundElements.setMode(TrueGrit.model.data.mode, 0.1);
        TrueGrit.foregroundElements = new TrueGritForegroundElements();
        TrueGrit.foregroundElements.setMode(TrueGrit.model.data.mode, 0.1);
        TrueGrit.reelBackgroundView = new TrueGritReelBackgroundView();
        TrueGrit.reelBackgroundView.setMode(TrueGrit.model.data.mode, 0.1);
        TrueGrit.winPresentations = new TrueGritWinPresentations();
        TrueGrit.allReelsView = new TrueGritMainAllReelsView();
        TrueGrit.trueGritScatterSymbols.addListener();
        TrueGrit.symbolBoxExplosionView = new TrueGritSymbolBoxExplosionView();
        TrueGrit.symbolBoxView = new TrueGritSymbolBoxView();
        TrueGrit.totalWinView = new TrueGritTotalWinView();
        TrueGrit.totalBigWinView = new TrueGritTotalBigWinView();
        TrueGrit.initialWinBelowView = new TrueGritInitialWinBelowView();
        TrueGrit.wildTransformView = new TrueGritWildTransformView();
        TrueGrit.reelSplitView = new TrueGritReelSplitView();
        TrueGrit.anticipationView = new TrueGritAnticipationView();
        TrueGrit.splitSymbolView = new TrueGritXWaysAndSplitView();
        TrueGrit.luckyDrawView = new TrueGritLuckyDrawView();
        TrueGrit.fsIntroView = new TrueGritFreeSpinIntroView();
        TrueGrit.fsToSuperFsIntroView = new TrueGritFSToSuperFSIntroView();
        TrueGrit.fsOutroView = new TrueGritFreeSpinOutroView();
        TrueGrit.superFsIntroView = new TrueGritSuperFreeSpinIntroView();
        TrueGrit.superFOutroView = new TrueGritSuperFreeSpinOutroView();
        TrueGrit.maxWinOutroView = new TrueGritMaxWinOutroView();
        TrueGrit.waysView = new TrueGritWaysView();
        TrueGrit.muzzleFlashView = new TrueGritMuzzleFlashView();

        NolimitApplication.addLayerAt(TrueGrit.muzzleFlashView.name, TrueGrit.muzzleFlashView, 0);
        NolimitApplication.addLayerAt(TrueGrit.winPresentations.name, TrueGrit.winPresentations, 0);
        NolimitApplication.addLayerAt(TrueGrit.fsIntroView.name, TrueGrit.fsIntroView, 0);
        NolimitApplication.addLayerAt(TrueGrit.superFsIntroView.name, TrueGrit.superFsIntroView, 0);
        NolimitApplication.addLayerAt(TrueGrit.fsToSuperFsIntroView.name, TrueGrit.fsToSuperFsIntroView, 0);
        NolimitApplication.addLayerAt(TrueGrit.scatterAnimationView.name, TrueGrit.scatterAnimationView, 0);
        NolimitApplication.addLayerAt(TrueGrit.totalWinView.name, TrueGrit.totalWinView, 0);
        NolimitApplication.addLayerAt(TrueGrit.totalBigWinView.name, TrueGrit.totalBigWinView, 0);
        NolimitApplication.addLayerAt(TrueGrit.symbolBoxExplosionView.name, TrueGrit.symbolBoxExplosionView, 0);
        NolimitApplication.addLayerAt(TrueGrit.initialWinTopView.name, TrueGrit.initialWinTopView, 0);
        NolimitApplication.addLayerAt(TrueGrit.waysView.name, TrueGrit.waysView, 0);
        NolimitApplication.addLayerAt(TrueGrit.foregroundElements.name, TrueGrit.foregroundElements, 0);
        NolimitApplication.addLayerAt(TrueGrit.wildTransformView.name, TrueGrit.wildTransformView, 0);
        NolimitApplication.addLayerAt(TrueGrit.anticipationView.name, TrueGrit.anticipationView, 0);
        NolimitApplication.addLayerAt(TrueGrit.splitSymbolView.name, TrueGrit.splitSymbolView, 0);
        NolimitApplication.addLayerAt(TrueGrit.reelSplitView.name, TrueGrit.reelSplitView, 0);
        NolimitApplication.addLayerAt(TrueGrit.symbolBoxView.name, TrueGrit.symbolBoxView, 0);
        NolimitApplication.addLayerAt(TrueGrit.initialWinBelowView.name, TrueGrit.initialWinBelowView, 0);
        NolimitApplication.addLayerAt(TrueGrit.topReelView.name, TrueGrit.topReelView, 0);
        NolimitApplication.addLayerAt(TrueGrit.bottomReelView.name, TrueGrit.bottomReelView, 0);
        NolimitApplication.addLayerAt(TrueGrit.allReelsView.name, TrueGrit.allReelsView, 0);
        NolimitApplication.addLayerAt(TrueGrit.reelBackgroundView.name, TrueGrit.reelBackgroundView, 0);
        NolimitApplication.addLayerAt(TrueGrit.snowParticles.name, TrueGrit.snowParticles, 0);
        NolimitApplication.addLayerAt(TrueGrit.backgroundElements.name, TrueGrit.backgroundElements, 0);
        NolimitApplication.addLayerAt(TrueGrit.gpuPushView.name, TrueGrit.gpuPushView, 0);
    }

    public static getBuyFeaturePrice():number {
        const betLevel: string = this.apiPlugin.freeBets.hasFreeBets() ? this.apiPlugin.freeBets.getBet() : this.apiPlugin.betLevel.getLevel();
        let price: number = this.model.gameData?.playedBetValue || parseFloat(betLevel);

        if (this.model.buyFeatureName) {
            for (let index:number = 0; index < this.model.initData.featureBuyTimesBetValue.length; index++) {
                if (this.model.initData.featureBuyTimesBetValue[index].name === this.model.buyFeatureName) {
                    price *= this.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }

        return price;
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "X",
                    "M3",
                    "L4",
                    "L2",
                    "M3",
                    "L5"
                ],
                [
                    "M1",
                    "L3",
                    "L3",
                    "L1",
                    "M2",
                    "L3"
                ],
                [
                    "M1",
                    "M3",
                    "M3",
                    "L2",
                    "M3",
                    "M4"
                ],
                [
                    "M5",
                    "M2",
                    "M2",
                    "L4",
                    "M4",
                    "L2"
                ],
                [
                    "X",
                    "L4",
                    "M2",
                    "L3",
                    "M",
                    "M1"
                ],
                [
                    "X",
                    "L1",
                    "L1",
                    "L5",
                    "W",
                    "L4"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "M3",
                    "L4",
                    "L2",
                    "M3"
                ],
                [
                    "M1",
                    "L3",
                    "L3",
                    "L1",
                    "M2"
                ],
                [
                    "M1",
                    "M3",
                    "M3",
                    "L2",
                    "X"
                ],
                [
                    "M5",
                    "M2",
                    "M2",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "L4",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "betWayWins": [],
            "totalBetWaySpinWinnings": 0,
            "thisAvalancheWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1.2,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "gameAreaSize": 0,
            "reelsAfterCollapse": [
                [
                    "X",
                    "M3",
                    "L4",
                    "L2",
                    "M3"
                ],
                [
                    "M1",
                    "L3",
                    "L3",
                    "L1",
                    "M2"
                ],
                [
                    "M1",
                    "M3",
                    "M3",
                    "L2",
                    "X"
                ],
                [
                    "M5",
                    "M2",
                    "M2",
                    "L4",
                    "X"
                ],
                [
                    "X",
                    "L4",
                    "M2",
                    "L3",
                    "X"
                ],
                [
                    "X",
                    "L1",
                    "L1",
                    "L5",
                    "X"
                ]
            ],
            "newSymbols": [],
            "totalAvalancheRoundWinnings": 0,
            "luckyDraw": false,
            "wasFeatureBuy": false,
            "topTrain": {
                "symbols": [
                    "M1",
                    "M1",
                    "M5"
                ],
                "beforeSpellSymbols": [
                    "M1",
                    "M1",
                    "M5"
                ],
                "winningSymThisSpin": [
                    false,
                    false,
                    false
                ],
                "transformSpellActivated": [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                "transformSpellTransform": [
                    [
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false
                    ]
                ]
            },
            "botTrain": {
                "symbols": [
                    "M3",
                    "M4",
                    "M",
                    "W"
                ],
                "isRevealed": [
                    false,
                    false,
                    false,
                    false
                ],
                "wildMult": 1,
                "highsLowTrain": {}
            },
            "greatBookOfWays": [
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            "superFS": false,
            "brokeBank": false
        };
    }
}